import HeroImage from './HeroImage'
import HeroImageWithTemplate from './HeroImageWithTemplate'


export default HeroImage
export { HeroImageWithTemplate }
